import { adminHttpClient } from '../../commons/adminHttpClient'
import OrderedPageFilter from '../../commons/orderedPageFilter'
import PagedList from '../../commons/pagedList'
import { NamedItem } from '../../../domain/common/namedItem'

export interface PagedInternalUsers extends PagedList<InternalUser> {}

export interface InternalUser {
  id: string
  fullname: string
  email: string
  roles: NamedItem[]
  createdAt: string
  status: NamedItem
  apps: string[]
}

export enum InternalUserStatus {
  Pending = 0,
  Active = 1,
  Deactivated = 4,
}

const getInternalUsers = (filter: OrderedPageFilter): Promise<any> => {
  filter = filter || {
    pageNumber: 1,
    pageSize: 10,
    orderColumn: 'createdAt',
    orderDescending: false,
  }

  return adminHttpClient.get('/csi/InternalUsers', filter)
}

export default getInternalUsers
